import { normalizeFields } from "@/forms/helpers";
import { formatSelectOptions } from "@/forms/validation";

export function createFormFields(profileDataInfo: ProfileDataInfo) {
  const dataInfo = profileDataInfo["doctor"];

  return normalizeFields({
    workplaces: {
      type: "multiselect",
      label: "Gdzie pracujesz?",
      options: formatSelectOptions(dataInfo.workplaces),
      value: [],
    },
  });
}
